import { useEffect, useState } from "react";
import DashboardLayout from "../Layouts/DashboardLayout";
import { useNavigate } from "react-router-dom";

export default function BranchReports() {
  const navigate = useNavigate();

  const [branches, setBranches] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadReports();
  }, []);

  const loadReports = async () => {
    try {
      const res = await fetch("/api/branch-reports", {
        credentials: "include",
      });

      const data = await res.json();

      if (data.status === "success") {
        setBranches(data.data);
        setSummary(data.summary);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <div className="p-10">Loading...</div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-8">
        <h1 className="text-2xl font-serif">Branch Reports</h1>

        {/* SUMMARY */}

        {summary && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Card title="Branches" value={summary.branches} />

            <Card
              title="Revenue"
              value={`₹${summary.total_revenue.toLocaleString()}`}
            />

            <Card title="Orders" value={summary.total_orders} />
          </div>
        )}

        {/* TABLE */}

        <div className="rounded-2xl bg-white/5 border border-white/10 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-black/40 text-gray-400">
              <tr>
                <th className="px-6 py-4 text-left">Branch</th>

                <th className="px-6 py-4">Revenue</th>

                <th className="px-6 py-4">Orders</th>

                <th className="px-6 py-4">Staff</th>

                <th className="px-6 py-4">Inventory</th>

                <th className="px-6 py-4">Action</th>
              </tr>
            </thead>

            <tbody>
              {branches.map((b) => (
                <tr
                  key={b.branch_id}
                  className="border-t border-white/10 hover:bg-white/5"
                >
                  <td className="px-6 py-4 font-medium">{b.branch}</td>

                  <td className="px-6 py-4 text-center">
                    ₹{b.revenue.toLocaleString()}
                  </td>

                  <td className="px-6 py-4 text-center">{b.orders}</td>

                  <td className="px-6 py-4 text-center">{b.staff}</td>

                  <td className="px-6 py-4 text-center">
                    <span
                      className={`px-3 py-1 rounded-full text-xs
                      ${
                        b.inventory === "Healthy"
                          ? "bg-green-500/20 text-green-400"
                          : b.inventory === "Moderate"
                            ? "bg-yellow-500/20 text-yellow-400"
                            : "bg-red-500/20 text-red-400"
                      }`}
                    >
                      {b.inventory}
                    </span>
                  </td>

                  <td className="px-6 py-4 text-center">
                    <button
                      onClick={() =>
                        navigate(`/admindashboard/branches/${b.branch_id}`)
                      }
                      className="px-4 py-1.5 rounded-lg text-xs
                      bg-amber-400/20
                      text-amber-400
                      hover:bg-amber-400
                      hover:text-black
                      transition"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}

function Card({ title, value }) {
  return (
    <div className="rounded-2xl bg-white/5 border border-white/10 p-6">
      <p className="text-xs uppercase tracking-widest text-gray-400">{title}</p>

      <p className="mt-3 text-3xl font-serif">{value}</p>
    </div>
  );
}
